import React, { useState } from "react";
import { CssBaseline, ThemeProvider, Grid } from "@mui/material"; // Import Grid from Material-UI
import { ColorModeContext, useMode } from "./theme";
import EventCoordinatorSidebar from "./EventCoordinatorScenes/global/EventCoordinatorSidebar";
import EventCoordinatorTopbar from "./EventCoordinatorScenes/global/EventCoordinatorTopbar";
import EventCoordinatorDashboard from "./EventCoordinatorScenes/dashboard/EventCoordinatorDashboard";

const EventCoordinator = () => {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(false);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Grid container className="app">
          {/* Sidebar */}
          <Grid item xs={2}>
            {" "}
            {/* Adjust the size according to your design */}
            <EventCoordinatorSidebar
              isCollapsed={isSidebar}
              setIsCollapsed={setIsSidebar}
            />
          </Grid>

          {/* Main content */}
          <Grid item xs={10}>
            {" "}
            {/* Adjust the size according to your design */}
            <Grid container direction="column">
              {/* Topbar */}
              <Grid item>
                <EventCoordinatorTopbar setIsSidebar={setIsSidebar} />
              </Grid>

              {/* EventCoordinatorDashboard */}
              <Grid item>
                <EventCoordinatorDashboard />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default EventCoordinator;
